<template>
  <div>
    <basic-container>
      <div>
        <el-form ref="form" :model="distributionForm">
          <el-form-item label="选择经销商" label-width="100px">
            <div style="display: flex;width:300px;">
              <el-select v-model="distributionForm.distributor" placeholder="请选择经销商" filterable="filterable" required
                value-key="id">
                <el-option v-for="distributor in distributors" :key="distributor.distributorId"
                  :label="distributor.distributorName" :value="distributor"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="出货产品配置" label-width="100px">
            <div v-for="(item, index) in distributionForm.distributionList" :key="index">
              <div>
                <div style="display: flex;width:375px;margin-bottom:25px;">
                  <el-select v-model="distributionForm.distributionList[index].goods" placeholder="请选择产品"
                    filterable="filterable" required @change="findSku(item, index)" value-key="id">
                    <el-option v-show="!isShow" v-for="goods in engineerGoodsList" :key="goods.id" :label="goods.name"
                      :value="goods"></el-option>
                  </el-select>
                  <div style="margin-left:20px;">
                    <el-button type="danger" size="small" plain @click="delRow(distributionForm.distributionList, index)">
                      删除
                    </el-button>
                  </div>
                </div>
                <div style="margin-bottom:50px;">
                  <el-table :data="distributionForm.distributionList[index].constitutes" border>
                    <template v-for="(col, index) in distributionForm.distributionList[
                      index
                    ].tableData1">
                      <el-table-column v-if="!col.hidden" sortable :show-overflow-tooltip="true" :prop="col.dataItem"
                        :label="col.dataName" :key="col.dataItem">
                        <template slot-scope="scope">
                          <el-input type="input" v-if="col.dataName == '出货量'" :disabled="col.disabled" :name="col.dataName" v-model="scope.row[index]"
                            :placeholder="col.placeholder"
                            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                            @input="handleNumberInput(scope.row.skuId, scope.row[index], index, col.dataName, col)"></el-input>
                          <el-input type="input" v-else :disabled="col.disabled" :name="col.dataName" v-model="scope.row[index]"
                            :placeholder="col.placeholder"
                            @input="handleNumberInput(scope.row.skuId, scope.row[index], index, col.dataName, col)"></el-input>
                        </template>
                      </el-table-column>
                    </template>
                  </el-table>
                </div>
              </div>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" plain
              @click="addRow(distributionForm.distributionList)">
              新增一行
            </el-button>
          </el-form-item>
        </el-form>
        <div
          style="width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:50px;margin-bottom:50px">
          <el-button type="primary" size="big" @click="submit">确定新增</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath } from "@/util/util";
import { findShopA } from "@/api/salesCloud/productOrderDetailsMerchant";
import {
  engineerGoodsSelect,
  addEngineerShipment,
  findProductGoodsById,
} from "@/api/salesCloud/shipmentManagement";

export default {
  data() {
    return {
      // tableOption: shipmentAddOption, //表格设置属性
      distributionForm: {
        distributor: {},
        shipmentSignGoods: {},
        distributionList: [{ goods: {}, tableData1: [], constitutes: [] }],
      },
      distributor: {},
      // goodsList: [],
      distributors: [],
      dataSku1: [],
      shipmentSignGoods: {},
      shipmentGoods: [],
      engineerGoodsList: [],
      isShow: false,
    };
  },
  created() {
    findShopA().then((res) => {
      let data = JSON.parse(res.data).rows;
      // console.log(data, 111);
      // console.log(this.shipmentGoods);
      this.distributors = data;
      this.shipmentGoods = DIC.SHIPMENT_TYPE;
    });
    engineerGoodsSelect().then((res) => {
      let data = JSON.parse(res.data);
      this.engineerGoodsList = data;
      // console.log(data, 88888);
    });
    // console.log(this.distributionForm.distributionList, "11111");
  },
  methods: {
    /**
     * 
     * @param {*} id  当前输入框的id
     * @param {*} number  当前输入框的值
     */
    handleNumberInput(id, number, index, dataName) {
      // console.log(col);
      number = Number(number);
      const inputNumber = number;
      const skuAmount = this.distributionForm.distributionList[0].dataSku1.find(
        (amount) => amount.id === id
      ).amount;
      // console.log(this.distributionForm.distributionList[0].dataSku1);
      // console.log(inputNumber, skuAmount,'111');
      this.validateNumberInput(id, inputNumber, skuAmount, index, dataName);
    },

    validateNumberInput(id, inputNumber, skuAmount, index, dataName) {
      if (inputNumber > skuAmount && dataName === "出货量") {
        this.$message({
          showClose: true,
          message: '出货量不能大于库存量' + skuAmount + '。',
          type: 'error'
        });

        // 将输入框的值设置为当前 SKU 的数量
        const skuIndex = this.distributionForm.distributionList[0].constitutes.findIndex(
          (amount) => amount.skuId === id
        );

        if (skuIndex !== -1) {
          // 使用 $nextTick 确保 DOM 更新后再修改值
          this.$nextTick(() => {
            this.$set(
              this.distributionForm.distributionList[0].constitutes[skuIndex],
              index,
              skuAmount.toString()
            );
          });
        }
      }
    },
    submit() {
      // console.log(this.distributionForm);
      let params = {};
      params.dealerId = this.distributionForm.distributor.distributorId;
      if (params.dealerId == null) {
        this.$message({
          showClose: true,
          message: '请选择经销商',
          type: 'error'
        });
        return;
      }
      // console.log(params);
      let goods = [];
      // console.log(this.distributionForm.distributionList);
      for (let i of this.distributionForm.distributionList) {
        // console.log(i, 8888);
        let obj = {};
        let conarr = i.constitutes;
        obj.goodsId = i.goods.id;
        obj.detailRequests = [];
        // console.log(i.constitutes.length);

        for (let j = 0; j < conarr.length; j++) {
          let cobj = conarr[j];
          let map = this.objToStrMap(cobj);
          // console.log(map, 999);
          let details = {};
          let num = 0;
          // console.log(i.dataSku1);
          for (let k = 0; k < i.dataSku1.length; k++) {
            if (k == 0) {
              let sku = i.dataSku1[k];
              // console.log(sku, 222);
              let skuArray = sku.skuValue.split(":");
              // console.log(skuArray);
              num = skuArray.length;
              break;
            }
          }
          let price = map.get(num + "");
          // console.log(price);
          let number = map.get(num + 1 + "");
          // console.log(number);
          details.price = price;
          details.number = number;
          details.skuId = map.get("skuId");
          if (details.number == '') {
            // console.log(details.number);
            // 去掉空的这一行
            continue;
          }
          obj.detailRequests.push(details);
        }
        // console.log(goods);
        goods.push(obj);
      }
      params.goodsRequests = goods;
      if (params.goodsRequests.length == 1&&params.goodsRequests[0].detailRequests.length == 0) {
        this.$message({
          showClose: true,
          message: '请填写出货产品配置',
          type: 'error'
        });
        return;
      }
      // console.log(params);
      // console.log(JSON.stringify(params), "params");
      addEngineerShipment(params).then((res) => {
        // console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          let item = {
            close: true,
            label: "新增出货",
            value: "/salesCloud/shipmentManagement/add",
          };
          this.$store.commit("DEL_TAG", item);
          let obj = {
            value: "/salesCloud/shipmentManagement",
            label: "出货管理",
          };
          this.$router.push({
            path: resolveUrlPath(obj.value, obj.label),
            query: obj.query,
          });
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },
    delRow(list, index) {
      // console.log(list, index);
      list.splice(index, 1);
    },
    addRow(list) {
      let addRow = {
        goodsList: [],
        goods: {},
        engineerGoodsList: [],
        tableData1: [],
        constitutes: [],
        dataSku1: [],
      };
      list.push(addRow);
    },
    findSku(item, index) {
      // console.log(item.goods, index);
      // 检查所选择的产品是否已存在于 distributionList 中
      const selectedGoodsId = item.goods.id;
      const alreadySelected = this.distributionForm.distributionList.some(
        (existingItem, idx) => idx !== index && existingItem.goods.id === selectedGoodsId
      );

      if (alreadySelected) {
        // 产品已经选择过，显示提示消息或者根据需求处理
        // 向用户显示一个消息，告知该产品已经选择过，不能重复选择
        this.$message({
          showClose: true,
          message: '该产品已经选择过，请选择其他产品。',
          type: 'warning'
        });
        // 并且执行删除操作
        this.distributionForm.distributionList.splice(index, 1);
        return; // 不执行后续的添加操作
      }
      this.distributionForm.distributionList[index].constitutes = [];
      // this.distributionForm.distributionList[0] = {};
      findProductGoodsById(item.goods.id).then((res) => {
        let data = JSON.parse(res.data);
        // console.log(data, 222);
        // this.sku = { id: data.skuId };
        this.formatConstitute(data.skuConstitute, index);
        // console.log(this.distributionForm.shipmentSignGoods, "155");
        // console.log(this.distributionForm.shipmentSignGoods, "166");
        this.distributionForm.distributionList[index].dataSku1 = data.dataSku;
        for (let i = 0; i < data.dataSku.length; i++) {
          let mapObj = new Map();
          let dataSku = data.dataSku[i];
          let map = this.objToStrMap(dataSku);
          let arrayVal = map.get("skuValue").split(":");
          let tableData2 = this.distributionForm.distributionList[index]
            .tableData1;

          for (let j = 0; j < tableData2.length; j++) {
            let obj1 = tableData2[j];
            if (typeof obj1.id != "undefined") {
              mapObj.set(obj1.flag, arrayVal[obj1.flag]);
            } else {
              mapObj.set(obj1.flag, map.get(obj1.dataItem));
            }
          }
          mapObj.set("skuId", dataSku.id);
          // console.log(this.strMapToObj(mapObj), 164);
          this.distributionForm.distributionList[index].constitutes.push(
            this.strMapToObj(mapObj)
          );
        }
      });
    },
    formatConstitute(data, index) {
      // console.log(data);
      let flag = 0;
      this.distributionForm.distributionList[index].tableData1 = new Array(
        data.length + 3
      );
      // console.log(data,this.distributionForm.distributionList[index].tableData1);
      for (let i = 0; i < data.length; i++) {
        let obj = {};
        obj.dataItem = data[i].constituteCode;
        obj.dataName = data[i].constituteName;
        obj.placeholder = data[i].constituteName;
        obj.id = data[i].id;
        obj.flag = flag;
        obj.disabled = true;
        this.distributionForm.distributionList[index].tableData1[flag] = obj;
        // this.distributionForm.distributionList[index].tableData1.push(obj)
        flag++;
      }
      this.distributionForm.distributionList[index].tableData1[flag] = {
        dataItem: "unitPrice",
        dataName: "产品单价",
        placeholder: "产品单价",
        hidden: true,
        flag: flag,
        disabled: false,
      };
      this.distributionForm.distributionList[index].tableData1[flag + 1] = {
        dataItem: "number",
        dataName: "出货量",
        placeholder: "出货量",
        flag: flag + 1,
        disabled: false,
      };
      // 库存量
      this.distributionForm.distributionList[index].tableData1[flag + 2] = {
        dataItem: "amount",
        dataName: "库存量",
        placeholder: "库存量",
        flag: flag + 2,
        disabled: true,
      };
      // console.log(this.distributionForm.distributionList, "4444444");
      //  console.dir(
      //   this.distributionForm.distributionList[index].tableData1,
      //   43434
      // );
    },
    objToStrMap(obj) {
      let strMap = new Map();
      for (let k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
      }
      return strMap;
    },
    strMapToObj(strMap) {
      let obj = Object.create(null);
      for (let [k, v] of strMap) {
        obj[k] = v;
      }
      return obj;
    },
    seeType: function () {
      if (this.distributionForm.shipmentSignGoods.value == "GENERAL_GOODS") {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      let obj = {};
      obj.constitutes = [];
      obj.goods = {};
      obj.tableData1 = [];
      let arry = [];
      arry.push(obj);
      this.distributionForm.distributionList = arry;
    },
  },
};
</script>
